module.exports = __webpack_public_path__ + "static/media/movilgo.c9c8a358.png";